module.exports = __webpack_public_path__ + "static/media/icon_31.3f32c1cb.svg";